import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import {
  ADMIN_LIST_SORT_OPTIONS,
  normalizeAdminListSort,
  type AdminListSort,
} from '../../lib/admin-list-sort';

interface AdminListSortSelectProps {
  value?: AdminListSort | string;
  onChange: (value: AdminListSort) => void;
  disabled?: boolean;
}

const AdminListSortSelect: React.FC<AdminListSortSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <label className="relative flex min-w-[190px] items-center">
    <span className="sr-only">Sắp xếp danh sách</span>
    <ArrowUpDown
      aria-hidden="true"
      className="pointer-events-none absolute left-3 h-4 w-4 text-gray-400"
    />
    <select
      aria-label="Sắp xếp danh sách"
      value={normalizeAdminListSort(value)}
      onChange={(event) => onChange(event.target.value as AdminListSort)}
      disabled={disabled}
      className="h-10 w-full cursor-pointer appearance-none rounded-md border border-gray-300 bg-white py-2 pl-9 pr-8 text-sm text-gray-700 transition-colors hover:border-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {ADMIN_LIST_SORT_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute right-3 h-4 w-4 text-gray-400"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  </label>
);

export default AdminListSortSelect;
